import MockAgentTransport from "./MockAgentTransport";
import SseAgentTransport from "./SseAgentTransport";
import OnboardingAgentTransport from "./OnboardingAgentTransport";

/**
 * Transport contract every implementation must satisfy:
 *   connect(conversationId, onEvent) -> unsubscribe()
 *   send(clientEvent) -> void   (fire-and-forget; replies arrive via onEvent)
 *   interrupt() -> void         (fire-and-forget; stops the in-flight turn)
 *   fetchTablePage?(tableId, page, pageSize) -> Promise (live only)
 *
 * LIVE is the default (real Gemini + MCP tools via the salesgear-mcp
 * orchestrator; API key in localStorage sg_copilot_api_key). The scripted
 * demo mock survives only behind an explicit sg_copilot_mock=1 flag. The
 * onboarding/digest flows are scripted client-side too, selected by `mode`.
 */
const isMockForced = () => {
  try {
    return localStorage.getItem("sg_copilot_mock") === "1";
  } catch (e) {
    return false;
  }
};

export const createAgentTransport = (mode = null) => {
  if (mode === "onboarding" || mode === "digest") {
    return new OnboardingAgentTransport(mode);
  }
  return isMockForced() ? new MockAgentTransport() : new SseAgentTransport();
};

export default createAgentTransport;
